import { AntPopover, Icons } from '@agro-club/agroclub-shared'
import { useAnalyticsClickHandler } from 'analytics/hooks'
import { FC, useState } from 'react'
import { AButton } from 'views/components/Analytics'
import { CardButtonWrapper, CardContentWrapper, ItemCard, TextCard } from 'views/styled/ItemCardStyles'
import { PopoverContent } from '../../../../components/PopoverContent/PopoverContent'
import { CarStatuses, LogisticsKRCar } from '../../../../types'
import { useCarsParams } from '../../Cars/useCarsParams'

type Props = {
  car: LogisticsKRCar
  refetch: () => Promise<void>
  onSelectedChanged: (carId: string) => void
  activeCarId: string
}

export const CarCard: FC<Props> = ({ car, refetch, onSelectedChanged, activeCarId }) => {
  const handleClick = useAnalyticsClickHandler('car')
  const [popoverVisible, setPopoverVisible] = useState(false)

  const info = useCarsParams(car)

  return (
    <ItemCard
      activeCard={car.id === activeCarId}
      status={car.status}
      onClick={handleClick(() => onSelectedChanged(car.id), { id: car.id })}
    >
      <CardContentWrapper>
        <TextCard thumbnail>
          {car.brand_model} {car.licence_number}
        </TextCard>
        {info.carInfo && <TextCard>{info.carInfo}</TextCard>}
        {info.extraInfo && <TextCard>{info.extraInfo}</TextCard>}
        <CardButtonWrapper>
          {car.status !== CarStatuses.archived && (
            <AntPopover
              content={<PopoverContent setPopoverVisible={setPopoverVisible} car={car} onSuccess={refetch} />}
              placement="bottomRight"
              trigger="click"
              open={popoverVisible}
              onOpenChange={() => setPopoverVisible(!popoverVisible)}
            >
              <AButton
                id="carActions"
                color="secondary"
                background="none"
                Icon={Icons.IconMoreHoriz}
                onClick={(e) => e.stopPropagation()}
              />
            </AntPopover>
          )}
        </CardButtonWrapper>
      </CardContentWrapper>
    </ItemCard>
  )
}
